import { render } from "./CommentPage.vue?vue&type=template&id=44e98bfc&scoped=true"
import script from "./CommentPage.vue?vue&type=script&lang=js"
export * from "./CommentPage.vue?vue&type=script&lang=js"

import "./CommentPage.vue?vue&type=style&index=0&id=44e98bfc&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e98bfc"]])

export default __exports__